import { render, staticRenderFns } from "./Taxonomies.vue?vue&type=template&id=32b62f5a&"
import script from "./Taxonomies.vue?vue&type=script&lang=ts&"
export * from "./Taxonomies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports